import React from 'react';

interface CompetePagesIconProps {
  size?: number;
  className?: string;
}

export const CompetePagesIcon: React.FC<CompetePagesIconProps> = ({
  size = 24,
  className = '',
}) => {
  return (
    <img
      src="/branding/competepages-icon.png"
      alt="CompetePages"
      width={size}
      height={size}
      className={`object-contain ${className}`}
    />
  );
};
